var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"red_top_bg"},[_c('div',{staticClass:"back_left",on:{"click":function($event){$event.stopPropagation();return _vm.handleBack.apply(null, arguments)}}}),_c('div',{staticClass:"big_tit"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"top_right",on:{"click":_vm.right_router}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }